import { render } from "./custom-field.vue?vue&type=template&id=34238616&scoped=true"
import script from "./custom-field.vue?vue&type=script&lang=js"
export * from "./custom-field.vue?vue&type=script&lang=js"

import "./custom-field.vue?vue&type=style&index=0&id=34238616&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34238616"]])

export default __exports__